import axios from "axios";
import { baseURL } from "../../../utils/http/http-common";
import { apiEndPoints } from "../../../utils/http";

export const GetAllMeeting = async (token) => {
  try {
    const response = await axios.get(
      "https://localhost:7222/api/Zoom/meetings",
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ✅ Use Bearer, not Basic
        },
      }
    );
    console.log(response);
    return response;
  } catch (error) {
    return error.config.data;
  }
};

export const GetMeetingById = async (meetingId) => {
  try {
    const response = await axios.get(
      `https://api.zoom.us/v2/meetings/${meetingId}`
    );
    console.log(response, "zoom api meeting all response");
    return response;
  } catch (error) {
    return error.config.data;
  }
};

export const GetZoomRefreshToken = async () => {
  try {
    const response = await axios.get("https://localhost:7222/api/Zoom/token");
    //console.log(response?.data?.refresh_token, "response refresh token");
    console.log(response, "zoom api zoom refresh token");
    return response?.data?.refresh_token;
  } catch (error) {
    console.log(error, "resfresh token error");
  }
};

export const GetZoomAccessToken = async (refreshToken) => {
  try {
    const response = await axios.get(
      `https://localhost:7222/api/Zoom/ZoomAuthGetToken/${refreshToken}`
    );
    console.log(response, "zoom api zoom access token response");
    return response?.data?.access_token;
  } catch (error) {
    console.log(error, "access token error");
  }
};
